// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer--lcAzu","footerInner":"footerInner--RlbSJ","cancelBtn":"cancelBtn--K1dqv","primaryGroup":"primaryGroup--womVO"};